import React from "react";
import SliderClasses from "./Slider.module.css";
import Person from "Assets/Homepage/Slider/Slider.png";
import Person_2 from "Assets/Homepage/Slider/slider_mini.png";
function Slider() {
    return (
        <div className={SliderClasses["Container"]}>
            <div className={SliderClasses["Content"]}>
                {/* <h2> </h2> */}
                {
                    <h3>
                        A Place where all your <br />
                        Tax needs are met!
                    </h3>
                }
                <button>Get Started</button>
            </div>
            <img alt="person" src={Person} />
        </div>
    );
}

export default Slider;
